import CommonOperationClass from '../../../commonOperationClass';

const two = new CommonOperationClass('2');

export default two;
